export const TOOL_AREA_ELEMENT_ORDER = [
    'interaction-notes',
    'interaction-contacts',
    'advisory-create-consumer-credit',
];
